<template>
  <section :data-theme="theme" v-intersection-observer="onIntersectionObserver">
    <div class="hero min-h-screen bg-base-100">
      <div class="hero-content flex-col lg:flex-row">
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div
            class="
              col-span-2
              md:col-span-1
              justify-center
              p-4
              h-[505px]
              hidden
              md:block
            "
          >
            <img :src="imageOnlineReading()" class="max-w-sm" />
          </div>
          <div class="mt-12 md:mt-0">
            <div class="col-span-2 md:col-span-1">
              <div>
                <h1 class="text-5xl font-bold mb-4">Lo que sé</h1>
              </div>
            </div>
            <div class="col-span-2 min-h:h-72 mt-4">
              <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div
                  v-for="skill in skills"
                  :key="skill.id"
                  class="
                    rounded-xl
                    col-span-1
                    sm:col-span-2
                    shadow-lg
                    flex
                    shadow-indigo-500/50
                    items-center
                    justify-center
                    space-x-2
                    p-2
                  "
                >
                  <div class="w-20 rounded">
                    <img
                      :src="
                        require(`@/assets/icons/skills/${skill.image}.webp`)
                      "
                      alt=""
                    />
                  </div>
                  <div>
                    <div class="text-lg font-extrabold">{{ skill.name }}</div>
                    <div class="text-base-content/70 text-sm">
                      {{ skill.level }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { vIntersectionObserver } from "@vueuse/components";

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}

const isVisible = ref(false);
const theme = ref("luxury");
const store = useStore();

const skills = computed(() => store.getters.getAllSKills);

const imageOnlineReading = () => {
  return require(`@/assets/images/online_reading.svg`);
};
</script>

<style>
</style>